/**
 * @generated SignedSource<<e62a29f85feabc0a4c85e7db4c6f0c9c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type SimilarRecentlySoldItemsPriceRange = "BETWEEN_HIGH_AVG_AND_MAX" | "BETWEEN_LOW_AVG_AND_MEDIAN" | "BETWEEN_MEDIAN_AND_HIGH_AVG" | "BETWEEN_MIN_AND_LOW_AVG" | "HIGHER_RANGE" | "LOWER_RANGE" | "MEDIAN" | "NEAR_MEDIAN" | "NEAR_MEDIAN_HIGH" | "NEAR_MEDIAN_LOW" | "OTHER" | "OUT_OF_RANGE_HIGH" | "OUT_OF_RANGE_LOW" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type useIsRareFind_item$data = {
  readonly isAuctionEnabled: boolean | null;
  readonly similarRecentlySoldItemsPrices: {
    readonly priceRange: SimilarRecentlySoldItemsPriceRange | null;
  } | null;
  readonly " $fragmentType": "useIsRareFind_item";
};
export type useIsRareFind_item$key = {
  readonly " $data"?: useIsRareFind_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"useIsRareFind_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "currency"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "useIsRareFind_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAuctionEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "currency",
          "variableName": "currency"
        }
      ],
      "concreteType": "SimilarRecentlySoldItemsPrices",
      "kind": "LinkedField",
      "name": "similarRecentlySoldItemsPrices",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "priceRange",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "f9e407fe2d28826d57e57532d6c822be";

export default node;
